import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import axios from "axios";
import "../../App.css";
import "./ResetPassword.css";
import { END_URL, IMG_URL } from '../../config';
import logoImg from '../../images/carter-logo.svg';


function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract token and email from URL query parameters
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const email = queryParams.get("email");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");


  const [CharacterState, setCharacterState] = useState(false);
  const [LetterNumberState, setLetterNumberState] = useState(false);

  const [BarState1, setBarState1] = useState("");
  const [BarState2, setBarState2] = useState("");
  const [BarState3, setBarState3] = useState("");
  const [BarState4, setBarState4] = useState("");


    const handlePasswordChange = (e) => {

          const value = e.target.value;

          // setShowPassword(value);

          const hasLettersAndNumbers = /^(?=.*[A-Za-z])(?=.*\d)/.test(value);
          const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);

          const is8OrMore = value.length >= 8;

          setCharacterState(is8OrMore);
          setLetterNumberState(hasLettersAndNumbers);

          if (value.length >= 1) {
            setBarState1("red");
          } else {
            setBarState1("");
          }

          if (is8OrMore || hasLettersAndNumbers) {
            setBarState2("yellow");
          } else {
            setBarState2("");
          }

          if (is8OrMore && hasLettersAndNumbers) {
            setBarState3("green");
          } else {
            setBarState3("");
          }

          if (is8OrMore && hasLettersAndNumbers && hasSpecialChar) {
            setBarState4("black_green");
          } else {
            setBarState4("");
          }
      };

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  const onSubmit = async (data) => {
    if (!token || !email) {
      setError("Invalid or missing password reset token/email.");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      // Replace with your actual API endpoint
      const response = await axios.post(
        `${END_URL}reset-password`,
        {
          token,
          email,
          password: data.password,
          password_confirmation: data.confirmPassword,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

        if (response.status === 200) {
          setSuccess("Password reset successfully! Redirecting to login...");
          setTimeout(() => navigate("/loginPage"), 2500);
        } else {

          setError(
            response.data.message ||
            "Password reset failed. Please try again."
          );
        }
    } catch (err) {

      const message =
      err.response?.data?.message ||
      err.response?.data?.error ||
      err.message ||
        "An unexpected error occurred while resetting password. Please try again.";

      setError(message);

    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="reset-password-wrapper">
      <div className="container">
        <div className="reset-password-box">
          <Link className="navbar-brand" to="/">
            <img src={logoImg} alt="Logo" />
          </Link>


          <h2>Reset Your Password</h2>
          <p>Create a new password for your participant portal.</p>

          {error && <div className="alert alert-danger">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          {!success && (
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <div className="input-group">
                <label htmlFor="password">New Password</label>
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters",
                    },
                    pattern: {
                      value: /^(?=.*[A-Za-z])(?=.*\d).{8,}$/,
                      message: "Use at least 8 characters including letters and numbers",
                    },
                  })}
                  autoComplete="new-password"
                  placeholder="Enter new password"
                  onChange={handlePasswordChange}

                />
                {showPassword ? (
                  <FaRegEye
                    onClick={() => setShowPassword(false)}
                    className="password-toggle-icon"
                    title="Hide password"
                  />
                ) : (
                  <FaRegEyeSlash
                    onClick={() => setShowPassword(true)}
                    className="password-toggle-icon"
                    title="Show password"
                  />
                )}
                {errors.password && (
                  <p className="error">{errors.password.message}</p>
                )}
              </div>

              <div class="meter" aria-hidden="true">
                <div id="b1" class={`bar ${BarState1}`} ></div>
                <div id="b2" class={`bar ${BarState2}`}  ></div>
                <div id="b3" class={`bar ${BarState3}`}  ></div>
                <div id="b4" class={`bar ${BarState4}`} ></div>
              </div>

              <div className="reset-tips">
                <p>Use at least 8 characters including letters and numbers.</p>

                  <ul className="charecter-text">
                    <li className={CharacterState ? 'active' : ''} >At least 8 characters</li>
                    <li  className={LetterNumberState ? 'active' : ''}> Contains letters and numbers</li>
                  </ul>
                  
              </div>

              <div className="input-group">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                  id="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  {...register("confirmPassword", {
                    required: "Please confirm your password",
                    validate: (value) =>
                      value === watch("password") || "Passwords do not match",
                  })}
                  autoComplete="new-password"
                  placeholder="Confirm new password"
                />
                {showConfirmPassword ? (
                  <FaRegEye
                    onClick={() => setShowConfirmPassword(false)}
                    className="password-toggle-icon"
                    title="Hide password"
                  />
                ) : (
                  <FaRegEyeSlash
                    onClick={() => setShowConfirmPassword(true)}
                    className="password-toggle-icon"
                    title="Show password"
                  />
                )}
                {errors.confirmPassword && (
                  <p className="error">{errors.confirmPassword.message}</p>
                )}
              </div>

              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? "Resetting..." : "Set New Password"}
              </button>
              <div className="reset-footer">
                <p>Changed your mind? <a href="#">Back to Login</a></p>
              </div>
              
            </form>
          )}
        </div>
      </div>
    </section>
  );
}

export default ResetPassword;
